import React, { useState, useEffect } from 'react';
import './HeaderText.css';
import Moon from '../../../../assets/svg/Moon';
import EarthFront from '../../../../assets/svg/EarthFront';
import EarthBack from '../../../../assets/svg/EarthBack';
import { Link } from 'react-router-dom';
import { useSiteBackground } from '../../../../context/SiteBackgroundContext';

const HeaderText = () => {
    const { isSiteReady } = useSiteBackground();
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (!isSiteReady) return undefined;

        const timer = setTimeout(() => {
            setIsActive(true);
        }, 500);

        return () => clearTimeout(timer);
    }, [isSiteReady]);

    return (
        <div className='headerTextWrapper'>
            <div className={`headerText ${isActive ? 'active' : ''}`}>
                <h1>
                    <span className='headerWord' style={{ transitionDelay: '0ms' }}>Hello, </span> 
                    <span className='headerWord' style={{ transitionDelay: '50ms' }}>I'm</span>
                </h1>
                <h1>
                    <span id="name" className='projectTextHeadingFancy'>
                        <span className='headerWord' style={{ transitionDelay: '300ms' }}>Kev</span>
                        <span className='headerWord' style={{ transitionDelay: '350ms' }}>in</span><br />
                        
                        <span className='headerWord' style={{ transitionDelay: '500ms' }}>Full</span><span className='headerWord' style={{ transitionDelay: '550ms' }}>er</span>
                        </span></h1>
                <h2 className='seniorTitle' data-title='Senior Software Engineer'>
                    <span className='headerWord seniorWord' style={{ transitionDelay: '900ms' }}>
                        Senior Software Engineer
                    </span>
                </h2>
                <p>
                    {"I build high-scale React and TypeScript products that improve performance, reliability, and delivery speed.".split(" ").map((word, index) => (
                        <span key={index} className='headerWord' style={{ transitionDelay: `${index * 40 + 1000}ms` }}>{word} </span>
                    ))}

                </p>
                <div className='heroActions'>
                    <a href="#projects" className='actionButton actionPrimary headerWord' style={{ transitionDelay: `${1440}ms` }}>
                        View Projects
                    </a>
                    <Link to="/resume" className='actionButton actionSecondary headerWord'  style={{ transitionDelay: `${1480}ms` }}>
                        Resume
                    </Link>
                </div>
            </div>

            <div  className={`earthGraphic ${isActive ? 'active' : ''}`}>
                <div className="planetContainer">
                    <div className="earth">
                        <EarthFront />
                        <EarthBack />
                    </div>
                    <Moon />
                </div>
            </div>
        </div>
    );
};

export default HeaderText;
